import {STORE_FEATURES} from '../constants'

export function storeFeatures(apiResponse) {
  return {type: STORE_FEATURES, features: apiResponse}
}
